<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path fill="currentColor" d="m2 11.546 3.273-4.364 2.659 3.545h1.023L6.868 7.96 9.091 5 14 11.546H2Z" />
    </svg>
</template>

<script setup lang="ts">
type TerrainIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<TerrainIconProps>();
</script>
